import React from 'react'
import { View } from 'react-native'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@components/base'
import { EhrAppointmentAttendanceChargeKind, EhrAppointmentStateKind } from '@src/types'
import { userSelector } from '@src/selectors/app'
import {
  FULL_DAY_MONTH_AND_DATE_FORMAT,
  VIDEO_CALL_DETAILS_MODAL_TIME_FORMAT,
} from '@src/config/momentFormat'
import { AppointmentPaymentMethodChip } from '../NextCall/Cards/AppointmentPaymentMethodChip'

interface AppointmentDetailsProps {
  title: string
  providerName?: string | null
  date: string
  chargeKind: EhrAppointmentAttendanceChargeKind
  appointmentState: EhrAppointmentStateKind
}

export const AppointmentDetails = ({
  title,
  providerName,
  date,
  chargeKind,
  appointmentState,
}: AppointmentDetailsProps) => {
  const styles = useStyleSheet(themedStyles)
  const user = useSelector(userSelector)

  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Text type="title-2" style={styles.title}>
          {title}
        </Text>
        <AppointmentPaymentMethodChip
          lastStateKind={appointmentState}
          chargeKind={chargeKind}
          style={styles.chip}
        />
      </View>

      {providerName && <Text type="large">{providerName}</Text>}

      <Text type="large">{moment(date).format(FULL_DAY_MONTH_AND_DATE_FORMAT)}</Text>

      <Text type="large" style={styles.timeAndTimeZone}>
        {moment(date).format(VIDEO_CALL_DETAILS_MODAL_TIME_FORMAT)}, {user?.timeZone || ''}
      </Text>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    marginBottom: 16,
  },
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: 8,
  },
  title: {
    flex: 1,
  },
  timeAndTimeZone: {
    color: 'theme.text.secondary',
  },
  chip: {
    top: -1,
  },
})
